export default __webpack_public_path__ + "static/media/color-lids.28087864.webp";